import React from "react";
import { FaMapMarkerAlt, FaWrench, FaStore, FaPhoneAlt } from "react-icons/fa";

const Showroom = () => {
  return (
    <section id="showroom" className="py-16 bg-gradient-to-br from-gray-100 via-blue-50 to-gray-200 scroll-mt-10">
      <div className="container mx-auto text-center px-4 sm:px-8 lg:px-16">
        <h2 className="text-4xl font-extrabold mb-4 text-blue-900 drop-shadow">Our Locations</h2>
        <p className="mb-10 text-lg text-gray-700">Visit our showrooms and service centers at these locations.</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 justify-center">
          {/* Saraswati Vihar Showroom */}
          <div className="bg-white rounded-2xl shadow-lg p-5 flex flex-col items-center transition-transform hover:-translate-y-1 hover:shadow-2xl border border-blue-100">
            <div className="mb-2 text-blue-700"><FaStore size={32} /></div>
            <h3 className="font-normal text-xl mb-1 text-blue-800">Saraswati Vihar Showroom</h3>
            <a href="https://maps.app.goo.gl/Sj7romERnTWvmUXF7" target="_blank" rel="noopener noreferrer" className="block w-full mb-2 group">
              <div className="overflow-hidden rounded-xl border-2 group-hover:border-blue-400 transition-all">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d224032.3936987367!2d76.81932449340823!3d28.713592245791618!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d01b1e2e2e2e3%3A0x7e2e2e2e2e2e2e2e!2sSaraswati%20Vihar%2C%20Pitampura%2C%20New%20Delhi%2C%20Delhi!5e0!3m2!1sen!2sin!4v1745476926734!5m2!1sen!2sin"
                  width="100%"
                  height="120"
                  style={{ border: 0, pointerEvents: 'none' }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Saraswati Vihar Showroom Map"
                ></iframe>
              </div>
            </a>
            <div className="flex items-center gap-2 mt-2 text-gray-700 text-sm">
              <FaMapMarkerAlt className="text-red-500" />
              HOUSE NO-303, Block B, Saraswati Vihar, Pitampura, New Delhi, Delhi, 110034
            </div>
            <a href="tel:+917838736859" className="flex items-center gap-2 mt-2 text-blue-700 hover:text-blue-900 font-semibold">
              <FaPhoneAlt /> +91 7838736859
            </a>
          </div>
         {/* Peeragarhi Showroom */}
          <div className="bg-white rounded-2xl shadow-lg p-5 flex flex-col items-center transition-transform hover:-translate-y-1 hover:shadow-2xl border border-blue-100">
            <div className="mb-2 text-blue-700"><FaStore size={32} /></div>
            <h3 className="font-normal text-xl mb-1 text-blue-800">Peeragarhi Showroom</h3>
            <a href="https://maps.app.goo.gl/Xq39t7ThRVGYw3bu7" target="_blank" rel="noopener noreferrer" className="block w-full mb-2 group">
              <div className="overflow-hidden rounded-xl border-2 group-hover:border-blue-400 transition-all">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3500.217964813674!2d77.07285707538244!3d28.68298257566309!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d0153e6c6621f%3A0xc877964e63cde573!2sExcellent%20Yamaha%20Motors!5e0!3m2!1sen!2sin!4v1745476926734!5m2!1sen!2sin"
                  width="100%"
                  height="120"
                  style={{ border: 0, pointerEvents: 'none' }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Peeragarhi Showroom Map"
                ></iframe>
              </div>
            </a>
            <div className="flex items-center gap-2 mt-2 text-gray-700 text-sm">
              <FaMapMarkerAlt className="text-red-500" />
              RR-11, near Peeragarhi metro station, Block A 2, Mianwali Nagar, Paschim Vihar, New Delhi, Delhi, 110087
            </div>
            <a href="tel:+917982920138" className="flex items-center gap-2 mt-2 text-blue-700 hover:text-blue-900 font-semibold" style={{ pointerEvents: "none" }}>
              <FaPhoneAlt /> +91 7982920138
            </a>
          </div>

          {/* Peeragarhi Workshop */}
          <div className="bg-white rounded-2xl shadow-lg p-5 flex flex-col items-center transition-transform hover:-translate-y-1 hover:shadow-2xl border border-green-100">
            <div className="mb-2 text-green-700"><FaWrench size={32} /></div>
            <h3 className="font-normal text-xl mb-1 text-green-800">Peeragarhi Service Centre</h3>
            <a href="https://maps.app.goo.gl/2r587ztakYqSxNND8" target="_blank" rel="noopener noreferrer" className="block w-full mb-2 group">
              <div className="overflow-hidden rounded-xl border-2 group-hover:border-green-400 transition-all">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3500.217964813674!2d77.07285707538244!3d28.68298257566309!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d0153e6c6621f%3A0xc877964e63cde573!2sExcellent%20Yamaha%20Motors!5e0!3m2!1sen!2sin!4v1745476926734!5m2!1sen!2sin"
                  width="100%"
                  height="120"
                  style={{ border: 0, pointerEvents: 'none' }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Peeragarhi Workshop Map"
                ></iframe>
              </div>
            </a>
            <div className="flex items-center gap-2 mt-2 text-gray-700 text-sm">
              <FaMapMarkerAlt className="text-red-500" />
              487/37, near Sidh baba mandir, Peera Garhi, Peeragarhi Village, Paschim Vihar, New Delhi, Delhi, 110087
            </div>
            <a href="tel:+918447347239" className="flex items-center gap-2 mt-2 text-green-700 hover:text-green-900 font-semibold">
              <FaPhoneAlt />+91 8447347239
            </a>
          </div>

          {/* Rithala Service Centre */}
          <div className="bg-white rounded-2xl shadow-lg p-5 flex flex-col items-center transition-transform hover:-translate-y-1 hover:shadow-2xl border border-green-100">
            <div className="mb-2 text-green-700"><FaWrench size={32} /></div>
            <h3 className="font-normal text-xl mb-1 text-green-800">Rithala Service Centre</h3>
            <a href="https://maps.app.goo.gl/MLxbSy66TzibyxtR7" target="_blank" rel="noopener noreferrer" className="block w-full mb-2 group">
              <div className="overflow-hidden rounded-xl border-2 group-hover:border-green-400 transition-all">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d224032.3936987367!2d76.81932449340823!3d28.713592245791618!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d01b1e2e2e2e3%3A0x7e2e2e2e2e2e2e2e!2sRithala%2C%20Rohini%2C%20New%20Delhi%2C%20Delhi!5e0!3m2!1sen!2sin!4v1745476926734!5m2!1sen!2sin"
                  width="100%"
                  height="120"
                  style={{ border: 0, pointerEvents: 'none' }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Rithala Service Centre Map"
                ></iframe>
              </div>
            </a>
            <div className="flex items-center gap-2 mt-2 text-gray-700 text-sm">
              <FaMapMarkerAlt className="text-red-500" />
              Khasra no.-132, near devi mata mandir, Rithala Extension, Rithala, Rohini, New Delhi, Delhi, 110085
            </div>
            <a href="tel:+918368321512" className="flex items-center gap-2 mt-2 text-green-700 hover:text-green-900 font-semibold">
              <FaPhoneAlt /> +918368321512
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Showroom;
